<template>
  <div
    style="height: 3.5rem; margin-bottom: 1rem"
    class="flex k_b1 concave-corners"
    :style="myStyle"
    :class="myClass"
  >
    <i class="k_top_left"></i>
    <i class="k_top_right"></i>
    <i class="k_bottom_left"></i>
    <i class="k_bottom_rigth"></i>
    <!-- Content -->
    <slot name="content"></slot>
  </div>
</template>
<script>
export default {
  name: "backgroundDiv",
  props: ["myClass", "myStyle"],
  data() {
    return {};
  },
  methods: {},
  created: function() {}
};
</script>
<style scoped>
.concave-corners /deep/ .el-input__inner {
  background-color: #0c284e;
  border: none;
  color: #fff;
  font-size: 20px;
}
.concave-corners {
  padding: 0 0.5% 0 1%;
  box-sizing: border-box;
  box-shadow: rgb(4, 91, 146) 0 0 18px inset;
  background-color: #0c284e;
  border: none;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/html/backgroundDiv.vue